import Vue from "vue";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faFileDownload, faTimes, faArrowLeft, faCloudUploadAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

export default function () {
  library.add(faFileDownload);
  library.add(faTimes);
  library.add(faArrowLeft);
  library.add(faCloudUploadAlt);

  Vue.component("font-awesome-icon", FontAwesomeIcon);
}
